import React from 'react';
import { Trans } from 'react-i18next';

import './style.scss';

export interface DateTimeProps {
  title?: string;
  date: Date;
  endDate?: Date;
  translationKey?: string;
  langcode: 'nl' | 'en';
}


const DateTime: React.FC<DateTimeProps> = (props) => {
  const {
    title,
    date,
    endDate,
    translationKey = 'components.datetime.default',
    langcode,
  } = props;

  const formatParams = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    locale: langcode === 'en' ? 'en-GB' : 'nl-NL',
  };

  return (
    <div className="DateTime">
      {title && (
        <h2 className="DateTime__title label--regular">
          {title}
        </h2>
      )}

      <div className="DateTime__text">
        <Trans
          i18nKey={translationKey}
          values={{
            date,
            endDate,
            formatParams: {
              date: formatParams,
              endDate: formatParams,
            },
          }}
          components={{
            Date: <time dateTime={date.toISOString().split('T')[0]} className="DateTime__time" />,
            ...(endDate && {
              EndDate: <time dateTime={endDate.toISOString().split('T')[0]} className="DateTime__time" />,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default DateTime;
